interface FormErrorBannerProps {
  message?: string | null;
  className?: string;
}

export function FormErrorBanner({
  message,
  className = 'p-3 bg-ybh-error/20 border border-ybh-error/40 rounded-lg text-sm text-ybh-error',
}: FormErrorBannerProps): JSX.Element | null {
  if (!message) return null;
  return <div className={className}>{message}</div>;
}
